import { useMemo } from 'react';

export const useValidationError = ({
  errorKey = '',
  validationError = new Map([
    ['', {}],
  ]),
}) => {
  return useMemo(() => {
    const has = validationError.has(errorKey);
    const details = validationError.get(errorKey) || { field: '', message: '' };
    return { has, details };
  }, [errorKey, validationError]);
};

export default useValidationError;
